import { Button } from "../../../components/ui/button";
import { Label } from "../../../components/ui/label";
import { Input } from "../../../components/ui/input";
import { X } from "lucide-react";

export const CategoriesForm = ({
  editingCategory,
  formData,
  setFormData,
  setIsDialogOpen,
  isDialogOpen,
  handleSubmit,
  onClose,
  isSubmitting,
  error,
  setError,
}) => {
  // Don't render the dialog if it's not open
  if (!isDialogOpen) return null;

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      setIsDialogOpen(false);
    }
    // Clear any form errors when closing
    if (setError) {
      setError(null);
    }
  };

  const handleOverlayClick = (e) => {
    // Close dialog when clicking on the overlay (not the content)
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit();
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 !mt-0"
      onClick={handleOverlayClick}
    >
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full transform animate-in zoom-in-95 duration-300">
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-xl font-semibold text-gray-900">
            {editingCategory ? "Edit Category" : "Add New Category"}
          </h2>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleClose}
            className="hover:bg-gray-100 rounded-full p-2"
            disabled={isSubmitting}
          >
            <X className="w-4 h-4 text-gray-500" />
          </Button>
        </div>

        {/* Form Content */}
        <form onSubmit={onSubmit} className="p-6">
          <div className="space-y-5">
            {/* Error Display */}
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-3 py-2 rounded-md text-sm">
                {error}
              </div>
            )}

            {/* Category Name */}
            <div className="space-y-2">
              <Label htmlFor="name">Category Name</Label>
              <Input
                id="name"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                placeholder="Enter category name"
                required
                disabled={isSubmitting}
              />
            </div>

            {/* Status - Changed from 'active' to 'status' */}
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="status"
                checked={formData.status}
                onChange={(e) =>
                  setFormData({ ...formData, status: e.target.checked })
                }
                disabled={isSubmitting}
              />
              <Label htmlFor="status">Active</Label>
            </div>

            {/* Action Buttons */}
            <div className="flex justify-end space-x-2 mt-8 pt-4 border-t border-gray-100">
              <Button 
                type="button"
                variant="outline" 
                onClick={handleClose}
                disabled={isSubmitting}
              >
                Cancel
              </Button>
              <Button 
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <div className="flex items-center">
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                    {editingCategory ? "Updating..." : "Creating..."}
                  </div>
                ) : (
                  editingCategory ? "Update Category" : "Create Category"
                )}
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};